import { defineComponent as _defineComponent } from 'vue'
import {
  Heading,
  BaseText,
  Row,
  InitialAvatarIcon,
  ButtonTertiary,
  ChipStatus,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import type { ProfitPreview } from '@/modules/trade/services/profit';
import { computed, onMounted } from 'vue';
import { tradeModule } from '@/modules/trade/store/trade';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

interface Props {
  profitPreview: ProfitPreview;
}

interface EmitEvents {
  (event: 'subscribe'): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfitPreviewContent',
  props: {
    profitPreview: null
  },
  emits: ["subscribe"],
  setup(__props: any) {

const props = __props as {
  profitPreview: ProfitPreview;
}





onMounted(async () => {
  await tradeModule.fetchStatus();
});

const shouldShowRLP = computed(() => {
  return FeatureFlagsModule.isEnabled(FeatureFlags.SHOW_RLP_PAGE);
});

const isRLPEnabled = computed(() => {
  return tradeModule.tradeStatus?.isRLPEnabled;
});

const shouldShowRPLButton = computed(() => {
  const hasButton = props.profitPreview.costs.button !== null;

  return hasButton && shouldShowRLP.value && !isRLPEnabled.value;
});

return { __sfc: true,props, shouldShowRLP, isRLPEnabled, shouldShowRPLButton, Heading, BaseText, Row, InitialAvatarIcon, ButtonTertiary, ChipStatus, HeadingDisplay, NebraskaColors }
}

})